import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useMemo } from 'react';
import { usePopper } from 'react-popper';
import { BKJDropdown } from '../../BKJDropdown/index.js';
import { mergeRefs } from '../../BKJSelect/utils/mergeRefs.js';
import { Portal } from '../../Portal/Portal.js';
import { getPopperOptions, optionsVariant } from '../BKJComboBoxAsync.utils.js';
import { useBKJComboBoxAsyncContext } from './BKJComboBoxAsync.context.js';
import { BKJComboBoxAsyncOptionsMapper } from './BKJComboBoxAsyncOptionsMapper.js';
const variantMap = {
    Search: 'SeamlessRounded',
};
export const BKJComboBoxOptions = ({ overrides = [] }) => {
    const { error, isOpen, parentRef, getMenuProps, anchorElement, dropdownElement, setDropdownElement, portalTargetElement, searchValue, isDropdownReverse, } = useBKJComboBoxAsyncContext();
    const popperOpts = useMemo(getPopperOptions, []);
    const { styles } = usePopper(anchorElement, dropdownElement, popperOpts);
    if (overrides.includes('NoInitialResults')) {
        if (typeof searchValue === 'string' && searchValue === '')
            return _jsx(Fragment, {});
    }
    return (_jsx(Portal, { targetElement: portalTargetElement, children: _jsx(BKJDropdown, { "$isOpen": isOpen, "$dropdownVariant": variantMap[optionsVariant], error: error, ...getMenuProps({
                ref: mergeRefs([parentRef, setDropdownElement]),
                style: styles['popper'],
            }), openBorderLocation: isDropdownReverse ? 'bottom' : 'top', children: isOpen && _jsx(BKJComboBoxAsyncOptionsMapper, { overrides: overrides }) }) }));
};
//# sourceMappingURL=BKJComboBoxAsyncOptions.js.map